export default "__VITE_ASSET__D93yLS1h__"